export const notShowErrorsRequests = [
    {
        url: 'admin/file',
        method: 'get'
    },
    {
        url: 'admin/file/resize',
        method: 'post'
    },
]
